// extracted by mini-css-extract-plugin
module.exports = {"links":"ProductSelector_links__3Zj4c","link":"ProductSelector_link__1xIBL"};